import { render } from "./PCNewWorkerRecord.vue?vue&type=template&id=11f56556&scoped=true"
import script from "./PCNewWorkerRecord.vue?vue&type=script&lang=js"
export * from "./PCNewWorkerRecord.vue?vue&type=script&lang=js"

import "./PCNewWorkerRecord.vue?vue&type=style&index=0&id=11f56556&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f56556"]])

export default __exports__